
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/check/onboard-users-with-layer",
      function () {
        return require("private-next-pages/docs/check/onboard-users-with-layer.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/check/onboard-users-with-layer"])
      });
    }
  